import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Params, RouterModule } from '@angular/router';
import { filter, mergeMap, Subscription, tap } from 'rxjs';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-customer-activation',
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './customer-activation.html',
  styleUrl: './customer-activation.scss'
})
export class CustomerActivation {
  /**
   * Variable which is used to hold all subscriptions for cleanup on component destroy.
   */
  private readonly subscriptions: Subscription = new Subscription();
  /**
   * Variable which is used to store the customer id.
   */
  private customerId!: string;
  /**
   * Variable which is used to check whether to display auctomer activation design or not.
   */
  public showPage: boolean = false;
  /**
   * Component constructor which is used to inject the required services.
   * @param route To manage navigation.
   * @param commonService To access the functions inside the CommonService.
   */
  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService) { }
  /**
   * Component OnInit life cycle hook.
   */
  public ngOnInit(): void {
    this.subscriptions.add(
      this.route.params.pipe(
        filter((params: Params) => !!params && !!params['id']),
        tap((params: Params) => {
          this.customerId = this.commonService.getParam(params['id']);
          if (!this.customerId) {
            console.log('Page Not Found');
            // this.router.navigate(['/page-not-found']);
          }
        }),
        filter(() => !!this.customerId),
        mergeMap(() => this.commonService.updateCustomerStatus({ id: this.customerId }))
      ).subscribe(
        (res) => {
          if (res) {
            this.showPage = true;
          }
        },
        (err) => {
          if (err && err.error && err.error.error) {
            console.log('Error: ', err.error.error);
          }
        }
      )
    );

  }
  // /**
  //  * Component AferViewInit lifecycle hook, Called after the view has been initialised.
  //  * And here we remove the pre loader.
  //  */
  // public ngAfterViewInit(): void {
  //   const loader: HTMLElement = this.renderer.selectRootElement('#pre-loader');
  //   loader.style.display = 'none';
  // }
  /**
   * Component OnDestroy life cycle hook.
   * And unsubscribe all the subscriptions in the component.
   */
  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
